var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-form",
          {
            ref: "formData",
            attrs: {
              model: _vm.formData,
              rules: _vm.rules,
              "label-position": _vm.labelPosition,
              "label-width": "150px",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersCode"),
                          prop: "supplierCode",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.supplierCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "supplierCode", $$v)
                            },
                            expression: "formData.supplierCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersName"),
                          prop: "supplierName",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.supplierName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "supplierName", $$v)
                            },
                            expression: "formData.supplierName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersAddress"),
                          prop: "address",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "address", $$v)
                            },
                            expression: "formData.address",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersCountry"),
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.country,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "country", $$v)
                            },
                            expression: "formData.country",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersProvince"),
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.province,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "province", $$v)
                            },
                            expression: "formData.province",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersCity"),
                          prop: "city",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.city,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "city", $$v)
                            },
                            expression: "formData.city",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersPostCode"),
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.postCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "postCode", $$v)
                            },
                            expression: "formData.postCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersTelephoneNo"),
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.telephoneNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "telephoneNo", $$v)
                            },
                            expression: "formData.telephoneNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("base.carriers.carriersEmailAddress"),
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "de-input",
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.formData.emailAddress,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "emailAddress", $$v)
                            },
                            expression: "formData.emailAddress",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "btn-row" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.saveCarrier("formData")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("common.save")))]
            ),
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.cancel },
              },
              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }